import React from "react";
import "./Info.css";
const Info = () => {
  return (
    <div className="info" style={{ backgroundColor: "#b9f5a0" }}>
      <div className="heading-container">
     
        <div className="heading-line"></div>
        <span>Day 3</span> 
        <div className="heading">Art for Earth, Colours of Change, Let Creativity Rearrange!</div>
      </div>
      <div className="text1">
      To promote sustainable shopping practices, students will encourage the use of cloth bags for groceries
instead of plastic bags. By making this simple switch, we can significantly reduce plastic waste and
protect our environment. Carrying the message, "Go green, bag the scene!"
      </div>
      <div className="text2">
      We will also promote the timeless principles of "Reduce, Reuse, Recycle" by encouraging everyone to
carry a non-plastic water bottle while stepping out of their homes. By avoiding single-use plastic
bottles, we can minimise waste and protect our environment. Remember, "Refill and reuse are the
sustainable paths we choose!
      </div>
      <div className="extra">
        <div className="date">
          <span style={{ fontWeight: "bold" }}>Date</span>:: 3 June 2023
        </div>
        {/* <div className="time">Time: 4:00 PM</div>
        <div className="location">Venue: Adminsitrative Building</div> */}
      </div>
    </div>
  );
};

export default Info;
